import { BuildingLinkConnectForm } from './BuildingLinkConnectForm'
import type { VendorConnectorProps } from './types'

export function BuildingLinkConnector({ onConnected }: VendorConnectorProps) {
  return <BuildingLinkConnectForm onConnected={() => onConnected?.()} />
}
